import { render } from "./Create75Liquidation2.vue?vue&type=template&id=bb4147a2"
import script from "./Create75Liquidation2.vue?vue&type=script&lang=js"
export * from "./Create75Liquidation2.vue?vue&type=script&lang=js"

import "./Create75Liquidation2.vue?vue&type=style&index=0&id=bb4147a2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__